import { Others } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';

import { colors } from 'styles/theme/colors';

import Tick from '../Checkbox/tick.svg';
import Times from './unchecked.svg';

export function Switch({ testId, ...restProps }: MUI.SwitchProps & { testId: string }) {
  return (
    <MUI.Switch
      {...restProps}
      data-testid={`${testId}_${restProps.checked ? Others.ON : Others.OFF}`}
      sx={{
        width: 48,
        height: 25,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          transform: 'translateX(1px) translateY(1px)',
          '&.Mui-checked': {
            transform: 'translateX(24px) translateY(1px)',
            color: 'common.white',
            '& + .MuiSwitch-track': {
              backgroundColor: colors.primaryBlue,
              opacity: 1,
              border: 'none',
            },
            '&::before': {
              position: 'absolute',
              top: 5,
              right: 28,
              content: '""',
              color: 'white',
              width: 13,
              height: 13,
              backgroundImage: `url(${Tick})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            },
          },
          '&:first-child::after': {
            position: 'absolute',
            top: 7,
            left: 30,
            content: '""',
            color: 'white',
            width: 10,
            height: 10,
            background: `url(${Times}) no-repeat top left`,
          },
          '&:hover .MuiSwitch-thumb': {
            boxShadow: 'none',
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: 'primary.main',
            border: `6px solid ${colors.textInverseDefault}`,
          },
        },
        '& .MuiSwitch-thumb': {
          width: 23,
          height: 23,
          boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.25)',
          color: 'common.white',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        '& .MuiSwitch-track': {
          borderRadius: '13px',
          border: (theme) => `1px solid ${theme.palette.grey[400]}`,
          backgroundColor: colors.baseGrey30,
          opacity: 1,
          transition: (theme) => theme.transitions.create(['background-color', 'border']),
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          backgroundColor: 'primary.light',
        },
      }}
    />
  );
}
